import React from 'react';

function RightsReminderCard() {
  return (
    <div className="ff-rights-card" data-testid="rights-reminder">
      <div className="ff-rights-icon">ℹ️</div>
      <div className="ff-rights-content">
        <h3>Representation Reminder</h3>
        <p>
          If this meeting could lead to discipline or questioning about your conduct, 
          you may want to request union representation where applicable. Review your 
          notes, stay factual, and avoid guessing.
        </p>
      </div>
    </div>
  );
}

export default RightsReminderCard;
